import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Seo from "@/components/Seo";
import { MaskedLine, FadeIn } from "@/components/Reveal";
import { seoPages } from "@/data/seoPages";

export default function NotFound() {
  useEffect(() => {
    const meta = document.head.querySelector('meta[name="robots"]');
    const prev = meta?.getAttribute("content");
    if (meta) meta.setAttribute("content", "noindex, follow");
    return () => {
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, []);

  return (
    <>
      <Seo
        title="Page introuvable — MSC Toitures"
        description="Cette page n'existe pas ou plus. Retrouvez MSC Toitures, couvreur dans le Val-de-Marne (94)."
        path="/404"
      />
      <section className="bg-midnight text-white grain relative overflow-hidden min-h-[70vh] flex items-center">
        <div className="absolute inset-0 blueprint-dark opacity-60" aria-hidden="true" />
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 py-24 w-full">
          <MaskedLine delay={0.05}>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-signal">Erreur 404</span>
          </MaskedLine>
          <h1 className="mt-6 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-5xl" data-testid="notfound-title">
            <MaskedLine delay={0.18}>Cette page est introuvable</MaskedLine>
          </h1>
          <FadeIn delay={0.4}>
            <p className="mt-6 text-white/70 max-w-xl leading-relaxed">
              L'adresse que vous cherchez n'existe pas ou a été déplacée. Retrouvez nos services de
              couverture dans le Val-de-Marne ou contactez-nous directement.
            </p>
          </FadeIn>
          <FadeIn delay={0.55} className="mt-8 flex flex-col sm:flex-row gap-4">
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="btn-sweep btn-sweep-light inline-flex items-center justify-center gap-3 whitespace-nowrap border border-white/40 text-white font-display font-bold text-base uppercase tracking-wide px-8 py-4 transition-colors duration-300"
            >
              Retour à l'accueil
            </Link>
            <a
              href="tel:0646300391"
              data-testid="notfound-call-button"
              className="btn-sweep inline-flex items-center justify-center gap-3 whitespace-nowrap bg-signal text-white font-display font-bold text-base uppercase tracking-wide px-8 py-4 transition-colors duration-300"
            >
              <Phone size={18} strokeWidth={1.5} />
              06 46 30 03 91
            </a>
          </FadeIn>
          <FadeIn delay={0.7}>
            <div className="mt-10 flex flex-wrap gap-2">
              {seoPages.slice(0, 6).map((p) => (
                <Link
                  key={p.slug}
                  to={`/${p.slug}`}
                  className="font-mono text-[11px] uppercase tracking-[0.08em] text-white/60 border border-white/20 px-4 py-2 hover:border-signal hover:text-signal transition-colors duration-300"
                >
                  {p.footerLabel}
                </Link>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>
    </>
  );
}
